// import Filter from './../views/Filter'
const Policy = () => import('./../views/Policy');

export default [

    {
        path: "/policy",
        name: "policy",
        component: Policy,
     
    },
 
];